import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import axiosInstance from '../../../../../shared/utils/axios';
import history from '../../../../../history';
import {NODEJS_API_URL} from '../../../../../config.json';
import styled from 'styled-components/macro';
import useQueryString from '../../../../../shared/utils/useQueryString';
import {LoadingSpinner} from '../../../../../shared';

const _iframe = styled.iframe`
  height: calc(100vh - 120px);
  width: 100%;
  border: none;
  margin-top: 40px;
`;

const Wealthbox = () => {
  const [url, setUrl] = useState('');
  const [accountID] = useQueryString('accountID');
  const [householdID] = useQueryString('householdID');
  const email = localStorage.getItem('email');
  const token = localStorage.getItem('token');
  const runAs = localStorage.getItem('runAs');
  let query = '';
  if (accountID) {
    query += `&accountID=${accountID}`;
  }
  if (householdID) {
    query += `&householdID=${householdID}`;
  }

  const renderWealthbox = () => axiosInstance.get('/auth/wealthbox/login?', {params: [email, token, runAs]})
    .then(function success() {
      setUrl(`${NODEJS_API_URL}/auth/wealthbox/login?email=${email}&token=${token}${runAs ? '&runAs=' + runAs : ''}${query || ''}`);
    })
    .catch(function setUpLinkage() {
      return history.push('/engage/wealthbox/login');
    });

  useEffect(() => {
    renderWealthbox();
  }, []);

  return <div>
    {
      !url
        ? <>
          <div>Connecting to Wealthbox...</div>
          <LoadingSpinner/>
        </>
        : <_iframe seamless={true} src={url}/>
    }
  </div>;
};

const mapStateToProps = state => ({
  session: state.session,
});

export default connect(mapStateToProps, null)(Wealthbox);

Wealthbox.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
};
